import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, BookMarked } from 'lucide-react';
import { bookContent } from '../data/bookContent';
import { ProgressBar } from '../components/ProgressBar';

export const TableOfContents = () => {
  return (
    <div data-testid="table-of-contents" className="min-h-screen bg-cream py-8 md:py-12">
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <Link 
            to="/"
            data-testid="back-home-btn"
            className="flex items-center gap-2 text-charcoal-light hover:text-sage transition-colors"
          >
            <Home className="w-5 h-5" />
            <span className="hidden sm:inline">Home</span>
          </Link>
          <Link 
            to="/journal"
            data-testid="to-journal-btn"
            className="flex items-center gap-2 text-charcoal-light hover:text-sage transition-colors"
          >
            <BookMarked className="w-5 h-5" />
            <span className="hidden sm:inline">My Journal</span>
          </Link>
        </div>

        {/* Title */}
        <div className="text-center mb-12 animate-fade-in">
          <h1 className="font-heading text-4xl md:text-5xl text-charcoal mb-2">
            {bookContent.title}
          </h1>
          <p className="font-heading text-lg text-charcoal-light italic">
            Table of Contents
          </p>
        </div>

        {/* Progress */}
        <div className="mb-12 p-6 bg-white rounded-xl shadow-sm">
          <ProgressBar />
        </div>

        {/* Chapters List */}
        <div className="space-y-4">
          {bookContent.chapters.map((chapter, index) => (
            <Link
              to={`/chapter/${chapter.id}`}
              key={chapter.id}
              data-testid={`toc-chapter-${chapter.id}`}
              className="group flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm hover:shadow-md transition-all animate-slide-up"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <img 
                  src={chapter.image} 
                  alt={chapter.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="flex-grow min-w-0">
                <span className="text-xs font-medium text-gold uppercase tracking-wider">
                  Chapter {chapter.id}
                </span>
                <h2 className="font-heading text-xl text-charcoal group-hover:text-sage transition-colors truncate">
                  {chapter.title}
                </h2>
                <p className="text-sm text-charcoal-light truncate">
                  {chapter.subtitle}
                </p>
              </div>
              <ChevronRight className="w-5 h-5 text-charcoal-light group-hover:text-sage group-hover:translate-x-1 transition-all flex-shrink-0" />
            </Link>
          ))}
        </div>

        {/* Start Reading CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/chapter/1"
            data-testid="start-reading-btn"
            className="inline-flex items-center gap-2 px-8 py-4 bg-sage text-white rounded-full font-medium hover:bg-sage-dark transition-all shadow-lg hover:shadow-xl"
          >
            Start Reading
            <ChevronRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  );
};
